import { Col } from "antd/es/grid";
import { Avatar, Badge, MenuProps, Row } from "antd";
import { Chat } from "enums/ChatType";
import { CrownOutlined, EllipsisOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";

import "./MustardChaItem.scss";

const getItemsForMessage = (chat: Chat): MenuProps["items"] => [
  {
    label: "Copy chat link",
    key: "0",
    onClick: () => {
      const foodie = chat.participants.find(
        (participant) => participant.participantType === "foodie"
      );

      if (!foodie) {
        return;
      }

      navigator.clipboard.writeText(
        `${process.env.REACT_APP_URL}signin-sauce?&user=${foodie.participantId}&returnRoute=/messenger/${chat._id}`
      );
    },
  },
];

export const MustardChaItem = ({
  chat,
  onClick,
  isActive,
  showSupportBadge = true,
}: {
  chat: Chat;
  onClick: () => void;
  isActive: boolean;
  showSupportBadge?: boolean;
}) => {
  const businessId = localStorage.getItem("businessId");
  const otherParticipants = chat.participants.filter(
    (participant) => participant.participantId !== businessId
  );

  const participant = otherParticipants[0];

  if (!participant) {
    return null;
  }

  const lastMessage = chat.messages[chat.messages.length - 1];

  return (
    <div
      key={`messenger-mustard-chat-item-${chat._id}`}
      className={`mustard-chat-item ${chat.unreadCount === 0 ? "faded" : ""} ${
        isActive ? "active" : ""
      }`}
    >
      <div className="mustard-chat-item__dropdown">
        <Dropdown
          menu={{ items: getItemsForMessage(chat) }}
          trigger={["click"]}
        >
          <Space>
            <div className="mustard-chat-item__dropdown-trigger">
              <EllipsisOutlined />
            </div>
          </Space>
        </Dropdown>
      </div>
      <Row className={`mustard-chat-item__container`} onClick={onClick}>
        <Col className="mustard-chat-item__participant-col">
          <div style={{ position: "relative" }}>
            <Avatar src={participant.avatarUrl} size={60} />
            {participant.isPremium && (
              <span
                className="diamond"
                style={{ position: "absolute", top: 0, right: 0 }}
              >
                <CrownOutlined />
              </span>
            )}
          </div>
          <div className="mustard-chat-item__participant-info">
            <div className="mustard-chat-item__participant-name">
              @{participant.participantName}
            </div>

            <div
              className="mustard-chat-item__context-info"
              style={{ flexDirection: "row" }}
            >
              {showSupportBadge && (
                <span className="mustard-chat-item__venue-address">
                  <Badge
                    color="blue"
                    count="Support"
                    style={{ backgroundColor: "#ffac39" }}
                  />
                </span>
              )}

              {chat.context.type === "foodie-mustard" && (
                <span className="mustard-chat-item__venue-address">
                  <Badge
                    count="Influencer"
                    style={{ backgroundColor: "#f30758" }}
                  />
                </span>
              )}
            </div>
          </div>
        </Col>
        <Col className="mustard-chat-item__message-col">
          <div className="mustard-chat-item__message-content">
            {lastMessage ? lastMessage.content : <i>No messages yet</i>}
          </div>
          <div className="mustard-chat-item__badge">
            <Badge
              count={chat.unreadCount}
              style={{ backgroundColor: "#ffac39" }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
